import { OMT_AMS_PORTAL_IMPERSONATE_URL_PARAM } from "@/constants";

/** Email used to open the OMT/AMS portal as that party. */
export function omtAmsImpersonateEmailFromAnswer(raw: unknown): string | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) {
    return null;
  }
  const obj = raw as Record<string, unknown>;
  if (typeof obj.email === "string" && obj.email.trim()) {
    return obj.email.trim();
  }
  const party = obj.party;
  if (party && typeof party === "object" && !Array.isArray(party)) {
    const nested = (party as Record<string, unknown>).email;
    if (typeof nested === "string" && nested.trim()) {
      return nested.trim();
    }
  }
  return null;
}

/** Deep-link into the OMT/AMS portal as the given party email. */
export function omtAmsImpersonatePortalHref(email: string): string {
  return `/omt-ams/dashboard?${OMT_AMS_PORTAL_IMPERSONATE_URL_PARAM}=${encodeURIComponent(email.trim())}`;
}
